{
  "zoneBase": {
    "summit": { "treeDensity": 0,   "rockDensity": 6, "dogDensity": 0,   "hikerDensity": 0.2, "npcRiderDensity": 0.3, "wildlifeDensity": 0,   "jumpFrequency": 0.3, "regionFrequency": 3, "gateFrequency": 0, "pickupFrequency": 0.3, "setPieceWeight": 0.3 },
    "scree":  { "treeDensity": 0,   "rockDensity": 8, "dogDensity": 0,   "hikerDensity": 0.3, "npcRiderDensity": 0.3, "wildlifeDensity": 0.5, "jumpFrequency": 0.4, "regionFrequency": 3, "gateFrequency": 0, "pickupFrequency": 0.3, "setPieceWeight": 0.3 },
    "meadow": { "treeDensity": 0,   "rockDensity": 4, "dogDensity": 0.4, "hikerDensity": 0.8, "npcRiderDensity": 0.4, "wildlifeDensity": 0.8, "jumpFrequency": 0.6, "regionFrequency": 2, "gateFrequency": 0, "pickupFrequency": 0.4, "setPieceWeight": 0.4 },
    "forest": { "treeDensity": 14,  "rockDensity": 2, "dogDensity": 0.2, "hikerDensity": 0.4, "npcRiderDensity": 0.6, "wildlifeDensity": 0.3, "jumpFrequency": 0.5, "regionFrequency": 3, "gateFrequency": 0, "pickupFrequency": 0.3, "setPieceWeight": 0.4 },
    "valley": { "treeDensity": 2,   "rockDensity": 2, "dogDensity": 0.6, "hikerDensity": 1,   "npcRiderDensity": 0.3, "wildlifeDensity": 0.2, "jumpFrequency": 0.6, "regionFrequency": 1, "gateFrequency": 0, "pickupFrequency": 0.4, "setPieceWeight": 0.5 }
  },
  "gradeMultiplier": { "green": 1.0, "red": 1.3, "black": 1.6 },
  "zoneRamp": { "start": 0.8, "end": 1.2, "transitionDip": 0.7 },
  "freeride": {
    "bands": [
      { "fromM": 0,    "scale": 0.4 },
      { "fromM": 250,  "scale": 0.7 },
      { "fromM": 500,  "scale": 0.9 },
      { "fromM": 1000, "scale": 1.1 },
      { "fromM": 1500, "scale": 1.3 },
      { "fromM": 2000, "scale": 1.5 }
    ],
    "softCapRate": 0.0005,
    "softCapExtra": 0.8
  },
  "caps": { "treeDensity": 30, "rockDensity": 16, "dogDensity": 2, "hikerDensity": 3, "npcRiderDensity": 2, "wildlifeDensity": 2, "jumpFrequency": 2, "regionFrequency": 6, "gateFrequency": 2, "pickupFrequency": 1, "setPieceWeight": 0.8 }
}
